module.exports = __webpack_public_path__ + "img/move_xl.c1284509.png";